export default __webpack_public_path__ + "images/26c347137faaf420a275b1905d98acb2.png";